import {
    SET_SEARCH_PARAMS,
    GET_SEARCH_RESULTS_ORDERS_LIST_DATA,
    GET_SEARCH_RESULTS_ORDERS_LIST_DATA_SUCCESS,
    GET_SEARCH_RESULTS_ORDERS_LIST_DATA_FAILURE,
    SHOW_HIDE_SEARCH_ORDER_LIST,
    TOGGLE_SEARCH_ORDER_MODAL,
    TOGGLE_TABLE_SEARCH_LOADER,
} from '../actions';

const initialState = {
    loading: false,
    searchParams: {
        account: '',
        hrefId: '',
        physician: '',
        surgeryDate: '',
        networkId: '',
        patientName: '',
        procedure: '',
        lotSerialNumber: '',
        myCaseRef: '',
        sapOrderId: '',
        purchaseOrderId: '',
        unidCaseId: '',
        trackingNumber: '',
        delivery: '',
        secondaryVendorCaseNo:'',
    },
    pageLimit: 50,
    isActionItem: true,
    pageNo: 0,
    sortOrder: 'DESC',
    sortParam: 'submitDate',
    statusCode: '',
    statusMessage: '',
    totalSearcResults: 0,
    searchResultOrderList: [],
    showSearchModal: false,
    showOrdersResult: false,
    tableLoader: true,
};

const AppliedOrdersSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: { ...action.payload },
            };
        case GET_SEARCH_RESULTS_ORDERS_LIST_DATA:
            return {
                ...state,
                loading: true,
                totalSearcResults: 0,
            };
        case GET_SEARCH_RESULTS_ORDERS_LIST_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                searchResultOrderList: action.data.orderList,
                totalSearcResults: action.data.totalSearcResults,
            };
        case GET_SEARCH_RESULTS_ORDERS_LIST_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SHOW_HIDE_SEARCH_ORDER_LIST:
            return {
                ...state,
                ...action.data,
            };
        case TOGGLE_SEARCH_ORDER_MODAL:
            return {
                ...state,
                showOrdersResult: action.data,
            };
        case TOGGLE_TABLE_SEARCH_LOADER:
            return {
                ...state,
                tableLoader: action.data,
            };
        default:
            return {
                ...state,
            };
    }
};

export default AppliedOrdersSearchReducer;
